import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Divider,
  Flex,
  FormLabel,
  Heading,
  Stack,
  Switch,
  useToast,
  VStack,
  Box,
  FormControl,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  // Checkbox,
  Spinner,
  Select,
  FormErrorMessage,
} from "@chakra-ui/react";
import { Formik, Form, Field, FieldProps } from "formik";
import TextInputField from "../TextInputField";
import { RegisterPromotoraFormValidationSchema } from "./registerPromotoraFormValidation";
import { CreditPromoter } from "@/models/creditPromoter.model";
import { useEffect, useState } from "react";
import BackButton from "../BackButton";
import { documentFormatter } from "@/utils/documentFormatter";
import { useNavigate, useParams } from "react-router-dom";
import {
  getCreditPromoterById,
  createCreditPromoter,
  updateCreditPromoter,
} from "@/services/creditPromoter.service";
import { associateFinancialSettings } from "@/services/financialSettings.service";
import { Bank } from "src/models/bank.model";
import { getBanks } from "@/services/bank.service";
import WhiteLabelForm from "../WhiteLabelForm";
import { updateWhiteLabel } from "@/services/whiteLabel.service";
import {
  getCommercialManagers,
  getOldestMasterByCreditPromoterId,
  registerUser,
  updateUser,
} from "@/services/user.service";
import { User } from "@/models/user.model";
import { Role } from "@/models/role.model";
import { getRoles } from "@/services/role.service";
import { formatPhone } from "@/utils/formatPhone";
import { cpfFormatter } from "@/utils/cpfFormatter";

import FinancialSettingsForm from "../FinancialSettingsForm";
import { CorbanCreditModalityEnum } from "@/models/corban.model";
import { getAllProducts } from "@/services/product.service";
import { getConsigAllProducts } from "@/services/consignado/product.service";
import { Product } from "@/models/product.model";
import { ConsigProduct } from "@/models/consignado-product.model";
import { createCreditType } from "@/services/creditType.service";

interface AdditionalFinancialSetting {
  id: string;
  creditType: string;
  financialSettingsId?: string | null;
  commission?: number;
  FinancialSettings?: any;
}

export default function PromotoraRegisterForm() {
  const [actualCreditPromoter, setActualCreditPromoter] =
    useState<CreditPromoter>();
  const [banks, setBanks] = useState<Bank[]>([]);
  const [additionalFinancialSettings, setAdditionalFinancialSettings] = useState<AdditionalFinancialSetting[]>([]);
  const [loadingBanks, setLoadingBanks] = useState(false);
  const [isWhiteLabelEnabled, setIsWhiteLabelEnabled] = useState(false);
  const [masterUser, setMasterUser] = useState<User>();
  const [isRoleSwitchEnabled, setIsRoleSwitchEnabled] = useState(false);

  const [isFGTSEnable, setIsFGTSEnable] = useState<boolean>(false);
  const [isFGTSProductsLoading, setIsFGTSProductsLoading] = useState<boolean>(false);
  const [isConsigEnable, setIsConsigEnable] = useState<boolean>(false);
  const [isConsigProductsLoading, setIsConsigProductsLoading] = useState<boolean>(false);

  const [consigProducts, setConsigProducts] = useState<ConsigProduct[]>([]);
  const [isZeCredito, setIsZeCredito] = useState(false);
  const [products, setProducts] = useState<Product[]>([]);
  const [commercialManagers, setCommercialManagers] = useState<User[]>([]);
  const [roles, setRoles] = useState<{
    comPromotora?: Role | null;
    semPromotora?: Role | null;
  }>({
    comPromotora: null,
    semPromotora: null,
  });

  const toast = useToast();
  const { id } = useParams();
  const navigate = useNavigate();
  const removeMask = (value: string) => value.replace(/\D/g, "");

  useEffect(() => {

    const fetchData = async () => {
      try {
        const parsedId = Number(id);
        const creditPromoter = await getCreditPromoterById(parsedId);
        const rolesData = await getRoles();
        setRoles({
          comPromotora: rolesData.find(
            (role) => role.name === "MASTER_PROMOTORA"
          ),
          semPromotora: rolesData.find(
            (role) => role.name === "MASTER_PROMOTORA"
          ),
        });
        const managersList = await getCommercialManagers();
        setCommercialManagers(managersList);
        try {
          if (creditPromoter?.id) {
            const oldestMasterUser = await getOldestMasterByCreditPromoterId(
              Number(id)
            );
            setMasterUser(oldestMasterUser);
          }
        } catch (masterError) {
          toast({
            title: "Aviso",
            description: "Não foi possível carregar o usuário master",
            status: "warning",
            duration: 5000,
            isClosable: true,
          });
        }

        if (creditPromoter) {

          setIsWhiteLabelEnabled(!!creditPromoter?.WhiteLabel?.id);
          setActualCreditPromoter(creditPromoter);

          const isFGTSEnable = creditPromoter?.CreditTypeCorbans?.find(c => c.credit_type === CorbanCreditModalityEnum.FGTS)?.enable ?? false
          setIsFGTSEnable(isFGTSEnable)
          const isConsigEnable = creditPromoter?.CreditTypeCorbans?.find(c => c.credit_type === CorbanCreditModalityEnum.CONSIG_WORKER)?.enable ?? false
          setIsConsigEnable(isConsigEnable)
          // Carregar Consignado CLT adicional (FinancialSettingsCorbans)
          if (creditPromoter.FinancialSettings && isConsigEnable) {
            const consignadoSettings =
              [{
                id: creditPromoter.FinancialSettings.id || `consignado-clt-${creditPromoter.FinancialSettings.id}`,
                creditType:CorbanCreditModalityEnum.CONSIG_WORKER,
                financialSettingsId: creditPromoter.FinancialSettings.id,
                commission: 0,
                FinancialSettings: creditPromoter.FinancialSettings
              }]

            setAdditionalFinancialSettings(consignadoSettings);
          }
        }
      } catch (err: any) {
        toast({
          title: "Erro ao carregar dados",
          description: err.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
      setLoadingBanks(true);
      try {
        const banksList = await getBanks(1, 100);
        if (banksList) setBanks(banksList.data);
      } catch (err: any) {
        toast({
          title: "Erro ao carregar dados",
          description: err.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      } finally {
        setLoadingBanks(false);
      }
    };
    fetchData();
  }, [id]);

  function verifyIsTokReal() {
    if (id && id !== "new" && id == "14") {
      return true;
    }
    return false;
  }

  function verifyIsZeCredito() {
    if (id == "3") {
      setIsZeCredito(true);
      return true;
    }
    return false;
  }

  useEffect(() => {
    if (!isFGTSEnable) return;
    const fetchData = async () => {
      setIsFGTSProductsLoading(true)
      const products = await getAllProducts(1, 9999);
      let filteredProducts = products.data;
      if (!verifyIsTokReal()) {
        filteredProducts = filteredProducts.filter(
          (p: Product) => p.name !== "GRANATOK 1" && p.name !== "GRANATOK 2"
        );
      }
      if (!verifyIsZeCredito()) {
        filteredProducts = filteredProducts.filter(
          (p: Product) => p.name !== "ZERO TAC ZDC"
        );
      }

      setProducts(filteredProducts);
      setIsFGTSProductsLoading(false)
    }

    fetchData()
  }, [isFGTSEnable]);

  useEffect(() => {
    if (!isConsigEnable) return;
    const getConsigProducts = async () => {
      setIsConsigProductsLoading(true)
      try {
        const consigProducts = await getConsigAllProducts();
        setConsigProducts(consigProducts);
      } catch (error) {
        console.error("Erro ao buscar produtos consignados:", error);
      } finally {
        setIsConsigProductsLoading(false)
      }
    };

    getConsigProducts();
  }, [isConsigEnable]);

  return (
    <Flex direction="column" width="100%">
      <BackButton routeTo="/promotoras" />

      <Card width="100%" display="flex" flexDir="column">
        <CardHeader width="100%">
          <Stack spacing={6}>
            <Heading fontFamily="Lexend Deca" fontSize="3xl" as="b">
              {id && id !== "new" ? "Editar Promotora" : "Adicionar Promotora"}
            </Heading>
            {id && id !== "new" && (
              <Heading as="b" size="md">
                Promotora Id - {actualCreditPromoter?.id}
              </Heading>
            )}
          </Stack>
        </CardHeader>

        <CardBody height="100%">
          <Formik
            initialValues={{
              commercialManagerId: actualCreditPromoter?.FinancialSettings?.commercialManagerId ?? undefined,
              creditPromoterId: actualCreditPromoter?.id ?? undefined,
              document: documentFormatter(actualCreditPromoter?.document ?? ""),
              legalName: actualCreditPromoter?.legalName ?? "",
              businessName: actualCreditPromoter?.businessName ?? "",
              financialSettingsId:
                actualCreditPromoter?.FinancialSettings?.id ?? actualCreditPromoter?.financialSettingsId ?? undefined,
              commission: actualCreditPromoter?.commission ?? 0,
              automaticApproval: actualCreditPromoter?.automaticApproval ?? false,
              masterUserId: masterUser?.id || "",
              masterUserName: masterUser?.name || "",
              masterUserLastName: masterUser?.lastName || "",
              masterUserCpf: cpfFormatter(masterUser?.document || ""),
              masterUserPhone: formatPhone(masterUser?.cellphone || ""),
              masterUserEmail: masterUser?.email || "",
              masterUserRole: masterUser?.roles || [],
              masterUserPassword: "",
              whiteLabelId: actualCreditPromoter?.WhiteLabel?.id ?? undefined,
              WhiteLabel: actualCreditPromoter?.WhiteLabel ?? undefined,
              financialSettingsConsignadoId: actualCreditPromoter?.financialSettingsId ?? undefined,
              isFGTSEnable: actualCreditPromoter?.CreditTypeCorbans?.find(c => c.credit_type === CorbanCreditModalityEnum.FGTS)?.enable ?? false,
              isConsigEnable: actualCreditPromoter?.CreditTypeCorbans?.find(c => c.credit_type === CorbanCreditModalityEnum.CONSIG_WORKER)?.enable ?? false,
            }}
            enableReinitialize
            onSubmit={async (values, { setSubmitting }) => {
              setSubmitting(true);
              const cleanedCNPJ = removeMask(values.document);
              const cleanedPhone = removeMask(values.masterUserPhone);
              const cleanedCpf = removeMask(values.masterUserCpf);

              const masterUserFields = [
                "masterUserName",
                "masterUserLastName",
                "masterUserCpf",
                "masterUserEmail",
                "masterUserPhone",
              ];

              const missingFields = masterUserFields.filter((field) => {
                const value = (values as any)[field];
                return !value || (Array.isArray(value) && value.length === 0);
              });

              if (missingFields.length > 0) {
                toast({
                  title: "Dados do usuário master incompletos",
                  description:
                    "Por favor, preencha todos os dados do usuário responsável pela Promotora antes de salvar.",
                  status: "error",
                  duration: 5000,
                  isClosable: true,
                });
                setSubmitting(false);
                return;
              }

              // Validar se todos os Consignado CLT foram salvos
              const unsavedCLT = additionalFinancialSettings.filter(
                (fs) => !fs.financialSettingsId || fs.financialSettingsId === null || fs.financialSettingsId.trim() === ''
              );

              // TODO: Validar se o CLT está ativo também
              if (unsavedCLT.length > 0) {
                toast({
                  title: "Dados de Consignado CLT incompletos",
                  description:
                    "Por favor, salve os dados financeiros do Consignado CLT antes de cadastrar a Promotora.",
                  status: "error",
                  duration: 5000,
                  isClosable: true,
                });
                setSubmitting(false);
                return;
              }

              if (id && id !== "new") {
                // Edit mode
                // TODO: Validar como fica a relação do produto habilitado com o financial settings
            
                try {
                  await updateCreditPromoter(parseInt(id), {
                    document: cleanedCNPJ!,
                    legalName: values.legalName?.toUpperCase(),
                    businessName: values.businessName?.toUpperCase(),
                    commission: Number(values.commission) || null,
                    automaticApproval: values.automaticApproval || false,
                    financialSettingsId: values.financialSettingsId!,
                  });

                  const userData: Partial<User> = {
                    id: values.masterUserId,
                    name: values.masterUserName.toUpperCase(),
                    lastName: values.masterUserLastName.toUpperCase(),
                    document: cleanedCpf,
                    cellphone: cleanedPhone,
                    roles: values.masterUserRole,

                    email: values.masterUserEmail.toLowerCase(),
                  };

                  if (values.masterUserPassword) {
                    userData.password = values.masterUserPassword;
                  }

                  if (values.masterUserId) {
                    userData.id = values.masterUserId;
                    await updateUser(userData);
                  } else {
                    userData.creditPromoterId = parseInt(id);
                    await registerUser(userData);
                  }

                  if (values.whiteLabelId) {
                    await updateWhiteLabel(values.whiteLabelId, {
                      creditPromoterId: parseInt(id),
                      name: values.businessName,
                    });
                  }

                  // Associar financial settings adicionais (apenas CONSIGNADO_CLT)
                  if (values?.financialSettingsConsignadoId) {
                    try {
                      await associateFinancialSettings({
                        financialSettingsId: values.financialSettingsConsignadoId,
                        creditPromoterId: parseInt(id),
                        creditType: CorbanCreditModalityEnum.CONSIG_WORKER
                      });
                    } catch (error) {
                      console.error("Erro ao associar financial settings:", error);
                    }
                  }

                  if (values?.financialSettingsId) {
                    try {
                      await associateFinancialSettings({
                        financialSettingsId: values.financialSettingsId,
                        creditPromoterId: parseInt(id),
                        creditType: CorbanCreditModalityEnum.FGTS
                      });
                    } catch (error) {
                      console.error("Erro ao associar financial settings:", error);
                    }
                  }

                  await createCreditType({
                    creditPromoterId: parseInt(id),
                    credit_type: CorbanCreditModalityEnum.FGTS,
                    enable: values?.isFGTSEnable ?? false,
                    api_enable: false,
                    userCanAccess: 'all'
                  });

                  await createCreditType({
                    creditPromoterId: parseInt(id),
                    credit_type: CorbanCreditModalityEnum.CONSIG_WORKER,
                    api_enable: false,
                    enable: values?.isConsigEnable ?? false,
                    userCanAccess: 'all'
                  });

                  toast({
                    title: "Promotora editada com sucesso",
                    description: `Promotora ${values.businessName} foi editada!`,
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                  });

                  navigate("/promotoras");
                } catch (error: any) {
                  toast({
                    title: "Erro ao editar Promotora",
                    description: error.message,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                  });
                }
              } else {
                // validar se o produto FGTS está ativo
                if ((isFGTSEnable || isConsigEnable) && !values.financialSettingsId) {
                  toast({
                    title: "Dados financeiros para o FGTS obrigatórios",
                    description:
                      "Por favor, preencha e salve os dados financeiros primeiro antes de salvar a Promotora.",
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                  });
                  setSubmitting(false);
                  return;
                }

                // validar se o produto CLT está ativo
                if ((isConsigEnable || isFGTSEnable) && !values.financialSettingsId) {
                  toast({
                    title: "Dados financeiros  obrigatórios",
                    description:
                      "Por favor, preencha e salve os dados financeiros primeiro antes de salvar a Promotora.",
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                  });
                  setSubmitting(false);
                  return;
                }
                try {
                  const creditPromoter = await createCreditPromoter({
                    document: cleanedCNPJ,
                    legalName: values.legalName.toUpperCase(),
                    commission: Number(values.commission),
                    businessName: values.businessName.toUpperCase(),
                    financialSettingsId: values.financialSettingsId,
                    WhiteLabel: values.WhiteLabel,
                  });

                  const userData: Partial<User> = {
                    name: values.masterUserName.toUpperCase(),
                    lastName: values.masterUserLastName.toUpperCase(),
                    document: cleanedCpf,
                    cellphone: cleanedPhone,
                    roles: values.masterUserRole,
                    creditPromoterId: creditPromoter.id,
                    corbanId: null,
                    email: values.masterUserEmail.toLowerCase(),
                    password: values.masterUserPassword,
                  };

                  await registerUser(userData);

                  if (values.whiteLabelId) {
                    await updateWhiteLabel(values.whiteLabelId, {
                      creditPromoterId: creditPromoter.id,
                      name: creditPromoter.businessName,
                    });
                  }

                  if (values?.financialSettingsId) {
                    try {
                      await associateFinancialSettings({
                        financialSettingsId: values.financialSettingsId,
                        creditPromoterId: creditPromoter.id,
                        creditType: CorbanCreditModalityEnum.FGTS
                      });
                    } catch (error) {
                      console.error("Erro ao associar FGTS financial settings:", error);
                    }
                  }

                  if (values?.financialSettingsConsignadoId) {
                    try {
                      await associateFinancialSettings({
                        financialSettingsId: values.financialSettingsConsignadoId,
                        creditPromoterId: creditPromoter.id,
                        creditType: CorbanCreditModalityEnum.CONSIG_WORKER
                      });
                    } catch (error) {
                      console.error("Erro ao associar Consignado financial settings:", error);
                    }
                  }


                  await createCreditType({
                    creditPromoterId: creditPromoter.id,
                    credit_type: CorbanCreditModalityEnum.FGTS,
                    api_enable: false,
                    enable: values.isFGTSEnable ?? false,
                    userCanAccess: 'all'
                  });

                  await createCreditType({
                    creditPromoterId: creditPromoter.id,
                    credit_type: CorbanCreditModalityEnum.CONSIG_WORKER,
                    enable: values?.isConsigEnable ?? false,
                    api_enable: false,
                    userCanAccess: 'all'
                  });

                  toast({
                    title: "Promotora cadastrada com sucesso",
                    description: `Promotora ${creditPromoter.businessName} foi cadastrada!`,
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                  });

                  navigate(`/promotoras/${creditPromoter.id}`);
                } catch (error: any) {
                  console.error("Erro na criação da Promotora:", error);
                  toast({
                    title: "Erro ao salvar Promotora",
                    description: error.message,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                  });
                }
              }

              setSubmitting(false);
            }}
            validationSchema={RegisterPromotoraFormValidationSchema}
          >
            {({ errors, touched, setFieldValue, values, isSubmitting, submitCount }) => {
              useEffect(() => {
                if (roles.comPromotora && values.masterUserRole.length === 0) {
                  setFieldValue("masterUserRole", [roles.comPromotora]);
                  setIsRoleSwitchEnabled(false);
                }
              }, [roles, values.masterUserRole.length, setFieldValue]);

              useEffect(() => {
                if (values.masterUserRole.length > 0) {
                  const role = values.masterUserRole[0];
                  const roleName = role.name;
                  setIsRoleSwitchEnabled(roleName === "MASTER_PROMOTORA");
                }
              }, [values.masterUserRole]);

              return (
                <Form autoComplete="off">
                  <VStack spacing={8} minW="100%">
                    <Flex
                      gap="2rem"
                      width="100%"
                      alignItems="flex-start"
                      mt={6}
                    >
                      <Heading fontFamily="Lexend Deca" fontSize="2xl" as="b">
                        Dados Promotora
                      </Heading>
                    </Flex>
                    <Flex gap="2rem" width="100%">
                      <TextInputField
                        name="businessName"
                        label="Nome Fantasia"
                        placeholder="GranaTech"
                        value={values.businessName}
                        error={errors.businessName}
                        touched={touched.businessName}
                        setFieldValue={setFieldValue}
                        isUpperCase
                      />
                      <TextInputField
                        name="document"
                        label="CNPJ da Promotora"
                        placeholder="00.000.000/0001-00"
                        value={values.document}
                        error={errors.document}
                        touched={touched.document}
                        setFieldValue={setFieldValue}
                        formatFn={documentFormatter}
                        maxLength={18}
                      />
                    </Flex>
                    <Flex gap="2rem" width="100%">
                      <TextInputField
                        name="legalName"
                        label="Razão Social"
                        placeholder="GranaTech LTDA"
                        value={values.legalName}
                        error={errors.legalName}
                        touched={touched.legalName}
                        setFieldValue={setFieldValue}
                        isUpperCase
                      />
                    </Flex>
                    <Flex
                      gap="2rem"
                      width="100%"
                      alignItems="flex-start"
                      flexDirection={{ base: "column", md: "row" }}
                    >
                      <Field name="commercialManagerId">
                        {({ field, form }: FieldProps) => {
                          const selectValue = field.value === null ? "null" : (field.value ?? "");

                          return (
                            <FormControl
                              isInvalid={
                                !!(
                                  form.errors.commercialManagerId &&
                                  form.touched.commercialManagerId
                                )
                              }
                            >
                              <FormLabel>Gerente Comercial</FormLabel>
                              <Select
                                {...field}
                                value={selectValue}

                                onChange={(e) => {
                                  const val = e.target.value;
                                  if (val === "null") {
                                    form.setFieldValue("commercialManagerId", null);
                                  } else {
                                    form.setFieldValue("commercialManagerId", val);
                                  }
                                }}
                              >
                                <option value="" disabled hidden>
                                  Selecione o Gerente Comercial
                                </option>
                                <option value="null"></option>
                                {commercialManagers.map((manager) => (
                                  <option key={manager.id} value={manager.id}>
                                    {manager.name} {manager.lastName}
                                  </option>
                                ))}
                              </Select>
                              <FormErrorMessage>
                                {form.errors.commercialManagerId as string}
                              </FormErrorMessage>
                            </FormControl>
                          );
                        }}
                      </Field>
                    </Flex>
                    <Flex
                      gap="2rem"
                      width="100%"
                      alignItems="flex-start"
                      mt={6}
                    >
                      <Heading fontFamily="Lexend Deca" fontSize="2xl" as="b">
                        Usuário master dessa Promotora
                      </Heading>
                    </Flex>
                    <Flex gap="2rem" width="100%">
                      <TextInputField
                        name="masterUserName"
                        autoComplete="off"
                        label="Nome do responsável"
                        placeholder="Nome"
                        value={values.masterUserName}
                        error={errors.masterUserName}
                        touched={touched.masterUserName}
                        setFieldValue={setFieldValue}
                        isUpperCase
                      />
                      <TextInputField
                        name="masterUserLastName"
                        label="Sobrenome do responsável"
                        placeholder="Sobrenome"
                        value={values.masterUserLastName}
                        error={errors.masterUserLastName}
                        touched={touched.masterUserLastName}
                        setFieldValue={setFieldValue}
                        isUpperCase
                      />
                      <TextInputField
                        name="masterUserPhone"
                        label="Telefone"
                        placeholder="(00) 00000-0000"
                        value={formatPhone(values.masterUserPhone)}
                        error={errors.masterUserPhone}
                        touched={touched.masterUserPhone}
                        setFieldValue={setFieldValue}
                      />
                    </Flex>
                    <Flex gap="2rem" width="100%">
                      <TextInputField
                        name="masterUserCpf"
                        label="CPF"
                        placeholder="000.000.000-00"
                        value={values.masterUserCpf}
                        error={errors.masterUserCpf}
                        touched={touched.masterUserCpf}
                        setFieldValue={setFieldValue}
                        formatFn={documentFormatter}
                        maxLength={14}
                      />
                      <TextInputField
                        name="masterUserEmail"
                        label="Email"
                        placeholder="email@exemplo.com"
                        value={values.masterUserEmail}
                        error={errors.masterUserEmail}
                        touched={touched.masterUserEmail}
                        setFieldValue={setFieldValue}
                        isLowerCase
                      />
                    </Flex>
                    <Flex gap="2rem" width="100%">
                      <TextInputField
                        name="masterUserPassword"
                        label="Senha"
                        type="password"
                        autoComplete="off"
                        placeholder="********"
                        value={values.masterUserPassword}
                        error={errors.masterUserPassword}
                        touched={touched.masterUserPassword}
                        setFieldValue={setFieldValue}
                      />
                      <Flex
                        width="60%"
                        justify="flex-start"
                        align="center"
                        mt="2rem"
                        gap="3rem"
                      >
                        <Flex align="center" gap="0.5rem">
                          <FormLabel htmlFor="masterRole" mb="0">
                            Pode criar usuários
                          </FormLabel>
                          <Switch
                            id="masterRole"
                            isChecked={isRoleSwitchEnabled}
                            onChange={(e) => {
                              setIsRoleSwitchEnabled(e.target.checked);
                              const newRole = e.target.checked
                                ? roles.semPromotora
                                : roles.comPromotora;
                              if (newRole) {
                                setFieldValue("masterUserRole", [newRole]);
                              }
                            }}
                          />
                        </Flex>
                      </Flex>
                    </Flex>

                    <Heading
                      fontFamily="Lexend Deca"
                      fontSize="2xl"
                      as="b"
                      gap="2rem"
                      width="100%"
                      alignItems="flex-start"
                      mt={6}
                    >
                      Produtos Habilitados:
                    </Heading>

                    <Divider borderColor="gray" borderWidth="1px" />

                    <FormControl display="flex" flexDirection="column" gap={3}>
                      <Box
                        display="flex"
                        justifyContent="left"
                        alignItems="center"
                        fontWeight="bold"
                        fontSize={20}
                        gap={3}
                      >
                        Habilitar FGTS
                        <Field name="isFGTSEnable">
                          {({ field, form }: any) => (
                            <Switch
                              isChecked={field.value}
                              onChange={(e) => {
                                form.setFieldValue("isFGTSEnable", e.target.checked)
                                setIsFGTSEnable(e.target.checked)
                              }}
                            >
                            </Switch>
                          )}
                        </Field>
                      </Box>

                      {(values?.isFGTSEnable) && (
                        // {(initialValues?.isFGTSEnable || values?.isFGTSEnable) && (
                        <FormControl>
                          <Box width="100%" overflowX="auto" my={6}>
                            <Table
                              colorScheme="gray"
                              width="60rem"
                              maxWidth="100%"
                              mx="auto"
                            >
                              <Thead>
                                <Tr>
                                  <Th textAlign="center">Nome do Produto</Th>
                                  <Th textAlign="center">Comissão</Th>
                                  {/* <Th textAlign="center">Selecionar</Th> */}
                                </Tr>
                              </Thead>
                              <Tbody>
                                {products &&
                                  products
                                    .sort((a, b) => {
                                      let order = [
                                        "ZERO TAC ZDC",
                                        "ZERO TAC",
                                        "LIGHT",
                                        "NORMAL",
                                        "POWER",
                                        "MAX",
                                        "ULTRA",
                                        "GRANATOK 1",
                                        "GRANATOK 2",
                                      ];

                                      if (isZeCredito) {
                                        order = order.reverse();
                                      }
                                      return (
                                        order.indexOf(a.name) - order.indexOf(b.name)
                                      );
                                    })
                                    .map((product) => {
                                      const colorMap: Record<string, string> = {
                                        "ZERO TAC ZDC": "pink.400",
                                        "GRANATOK 1": "red.300",
                                        "GRANATOK 2": "red.400",
                                        "ZERO TAC": "blue.200",
                                        LIGHT: "blue.700",
                                        NORMAL: "gray.400",
                                        POWER: "green.300",
                                        MAX: "yellow.400",
                                        ULTRA: "orange.400",
                                      };
                                      const rowColor = colorMap[product.name];
                                      return (
                                        <Tr key={product.id} bg={rowColor}>
                                          <Td textAlign="center" color="white">
                                            {product.name}
                                          </Td>
                                          <Td textAlign="center" color="white">
                                            {parseFloat(
                                              (product.partnerPercentage! * 100).toFixed(
                                                3
                                              )
                                            )}
                                            %
                                          </Td>
                                          {/* <Td textAlign="center"> */}
                                          {/* <Field name="products"> */}
                                          {/* {({ form }: any) => {
                                                const isChecked =
                                                  form.values.products?.some(
                                                    (p: Product) => p.id === product.id
                                                  );

                                                const handleChange = () => {
                                                  if (isChecked) {
                                                    const updatedProducts =
                                                      form.values.products.filter(
                                                        (p: Product) =>
                                                          p.id !== product.id
                                                      );
                                                    form.setFieldValue(
                                                      "products",
                                                      updatedProducts
                                                    );
                                                    setSelectedFgtsProducts(
                                                      updatedProducts
                                                    );
                                                  } else {
                                                    const newProducts = [
                                                      ...form.values.products,
                                                      product,
                                                    ];
                                                    form.setFieldValue(
                                                      "products",
                                                      newProducts
                                                    );
                                                    setSelectedFgtsProducts(newProducts);
                                                  }
                                                };

                                                return (
                                                  );
                                                  }} */}
                                          {/* <Checkbox
                                              colorScheme="green"
                                              isChecked={true}
                                            // isChecked={isChecked}
                                            // onChange={handleChange}
                                            /> */}
                                          {/* </Field> */}
                                          {/* </Td> */}
                                        </Tr>
                                      );
                                    })}
                              </Tbody>
                            </Table>
                            {(isFGTSProductsLoading && products.length === 0) && (
                              <Flex width='100%' justifyContent='center' mt={4}>
                                <Spinner color="primary" size="lg" speed="0.65s" />
                              </Flex>
                            )}
                          </Box>
                        </FormControl>
                      )}
                      <Box
                        display="flex"
                        justifyContent="left"
                        alignItems="center"
                        fontWeight="bold"
                        fontSize={20}
                        gap={3}
                      >
                        Consignado CLT
                        <Field name="isConsigEnable">
                          {({ field, form }: any) => (
                            <Switch
                              isChecked={field.value}
                              onChange={(e) => {
                                form.setFieldValue("isConsigEnable", e.target.checked)
                                setIsConsigEnable(e.target.checked);
                              }}
                            />
                          )}
                        </Field>
                      </Box>

                      {(values?.isConsigEnable) && (
                        <FormControl>
                          <Box width="100%" overflowX="auto" my={6}>
                            <Table
                              colorScheme="gray"
                              width="60rem"
                              maxWidth="100%"
                              mx="auto"
                            >
                              <Thead>
                                <Tr>
                                  <Th textAlign="center">Nome do Produto</Th>
                                  <Th textAlign="center">Comissão</Th>
                                  {/* <Th textAlign="center">Selecionar</Th> */}
                                </Tr>
                              </Thead>
                              <Tbody>
                                {consigProducts &&
                                  consigProducts.map((product) => {
                                    return (
                                      <Tr key={product.id} bg={product.cor}>
                                        <Td textAlign="center" color="white">
                                          {product.nome}
                                        </Td>
                                        <Td textAlign="center" color="white">
                                          {product?.comissao! ? parseFloat(
                                            `${(product?.comissao! * 100).toFixed(3)}%`
                                          ) : '-'}
                                        </Td>
                                        {/* <Td textAlign="center"> */}
                                        {/* <Field name="consigProducts"> */}
                                        {/* {({ form }: any) => {
                                              const isChecked =
                                                form.values.consigProducts?.some(
                                                  (p: ConsigProductCorbans) =>
                                                    p.productId === product?.id
                                                );

                                              const handleChange = () => {
                                                if (isChecked) {
                                                  const updatedProducts =
                                                    form.values.consigProducts.filter(
                                                      (p: ConsigProductCorbans) =>
                                                        p.productId !== product.id
                                                    );
                                                  form.setFieldValue(
                                                    "consigProducts",
                                                    updatedProducts
                                                  );
                                                  setSelectedConsigProducts(
                                                    updatedProducts
                                                  );
                                                } else {
                                                  const newProduct = {
                                                    productId: product.id,
                                                    corbanId: values.id,
                                                    ...product,
                                                  };
                                                  const newProducts = [
                                                    ...(form.values.consigProducts || []),
                                                    newProduct,
                                                  ];
                                                  form.setFieldValue(
                                                    "consigProducts",
                                                    newProducts
                                                  );
                                                  setSelectedConsigProducts(newProducts);
                                                }
                                              };

                                              return (
                                                
                                              );
                                            }} */}
                                        {/* <Checkbox
                                            colorScheme="green"
                                            isChecked={true}
                                          // isChecked={isChecked}
                                          // onChange={handleChange}
                                          /> */}
                                        {/* </Field> */}
                                        {/* </Td> */}
                                      </Tr>
                                    );
                                  })}
                              </Tbody>
                            </Table>
                            {(isConsigProductsLoading && consigProducts.length === 0) && (
                              <Flex width='100%' justifyContent='center' mt={4}>
                                <Spinner color="primary" size="lg" speed="0.65s" />
                              </Flex>
                            )}
                          </Box>
                        </FormControl>
                      )}
                    </FormControl>

                    {(values?.isFGTSEnable || values?.isConsigEnable) && (
                      <>
                        <Flex
                          gap="2rem"
                          width="100%"
                          alignItems="flex-start"
                          mt={6}
                        >
                          <Heading fontFamily="Lexend Deca" fontSize="2xl" as="b">
                            Configurações Financeiras
                          </Heading>
                        </Flex>

                        <FinancialSettingsForm
                          isNew={
                            id === "new"
                          }
                          initialData={{
                            ...actualCreditPromoter?.FinancialSettings,
                            commission: values.commission,
                          }}
                          onSubmit={(data) => {
                            setFieldValue("commission", data.commission);
                            setFieldValue(
                              "financialSettingsId",
                              data.financialSettingsId
                            );
                          }}
                          hasPromoter={false}
                          banks={banks}
                          loadingBanks={loadingBanks}
                          document={values.document}
                          commercialManagerId={values.commercialManagerId}
                        />

                        <Divider />
                      </>
                    )}

                  
                    <Flex gap="1rem" width="100%" alignItems="center">
                      <FormLabel htmlFor="whiteLabelSwitch">
                        É white label
                      </FormLabel>
                      <Switch
                        id="whiteLabelSwitch"
                        isChecked={isWhiteLabelEnabled}
                        onChange={(e) =>
                          setIsWhiteLabelEnabled(e.target.checked)
                        }
                      />
                    </Flex>
                    {isWhiteLabelEnabled && (
                      <VStack w="100%" spacing={8}>
                        <Heading
                          fontFamily="Lexend Deca"
                          fontSize="2xl"
                          as="b"
                          gap="2rem"
                          width="100%"
                          alignItems="flex-start"
                          mt={6}
                        >
                          White Label
                        </Heading>
                        <WhiteLabelForm
                          isNew={!values.WhiteLabel}
                          initialData={values.WhiteLabel}
                          onSubmit={(data) => {
                            setFieldValue("whiteLabelId", data.whiteLabelId);
                            setFieldValue("WhiteLabel", data.whiteLabel);
                          }}
                        />
                      </VStack>
                    )}
                    <Flex justify="center" direction="column" align="center">
                      <Button
                        colorScheme="green"
                        type="submit"
                        variant="outline"
                        width="16rem"
                        // isDisabled={
                        //   isSubmitting || Object.keys(errors).length > 0 || ((isFGTSEnable && !values.financialSettingsId) || (isConsigEnable && !values.financialSettingsConsignadoId))
                        // }
                        isLoading={isSubmitting}
                        loadingText="Salvando"
                      >
                        {id && id !== "new"
                          ? "Salvar Alterações"
                          : "Cadastrar Promotora"}
                      </Button>
                      {(errors.financialSettingsId && submitCount > 0) && (
                        <Box
                          color="red.500"
                          fontSize="sm"
                          mt={2}
                          textAlign="center"
                        >
                          {errors.financialSettingsId!}
                        </Box>
                      )}

                      {(isFGTSEnable || isConsigEnable) && !values.financialSettingsId && (
                        <Box
                          color="red.500"
                          fontSize="sm"
                          mt={2}
                          textAlign="center"
                        >
                          Salve os dados financeiros primeiro
                        </Box>
                      )}

                  

                      {Object.keys(errors).length > 0 && submitCount > 0 && (
                        <Box
                          color="red.500"
                          fontSize="sm"
                          mt={4}
                          textAlign="center"
                          border="1px solid"
                          borderColor="red.500"
                          borderRadius="md"
                          p={3}
                          width="100%"
                          maxWidth="500px"
                        >
                          <strong>Verifique os seguintes erros:</strong>
                          <ul style={{ listStyleType: "none", padding: 0, marginTop: "8px" }}>
                            {Object.entries(errors).map(([key, error]) => {
                              // Ignorar financialSettingsId pois ele já possui um feedback visual próprio na tela
                              if (key === "financialSettingsId" || key === "financialSettingsConsignadoId") return null;
                              return <li key={key}>{String(error)}</li>;
                            })}
                          </ul>
                        </Box>
                      )}
                    </Flex>
                  </VStack>
                </Form>
              );
            }}
          </Formik>
        </CardBody>
      </Card>
    </Flex>
  );
}
